import axiosInstance from 'api/axiosInstance';

type BEFinConsents = {
  intervatApi: boolean;
  mmfApi: boolean;
};

export interface BEFinSessionResponse {
  isSessionActive: boolean;
  expiresIn?: number; // in seconds
  consents?: BEFinConsents;
  isManualSyncAvailable?: boolean;
  expirationDate?: string;
  sessionVATNumber?: string;
}
export const getBEFinSession = async (): Promise<BEFinSessionResponse> =>
  axiosInstance.get('v2/users/minfin/session');

export const loginToBEFin = async (
  redirectUrl: string,
): Promise<{ authUri: string }> =>
  axiosInstance.get(`/v2/users/minfin/login?redirectUrl=${redirectUrl}`, {
    ignoreToast: true,
  });

export const syncBEFinSession = async (): Promise<{ ok: boolean }> =>
  axiosInstance.post<any, { ok: boolean }>('v2/users/minfin/synchronize');

export const deleteBEFin = async (): Promise<void> =>
  axiosInstance.delete('v2/users/minfin');
